import React from 'react';
import '../../styles/components/AsperaBreadcrumbs.scss';
import { withRouter } from 'react-router-dom';
import { tracking } from '../../services/TrackingService';
import { language } from '../../services/LanguageService';
import { Breadcrumb, BreadcrumbItem, OverflowMenu, OverflowMenuItem, getIconComponent } from '../Carbon';
/**
 * React Component
 *
 * The AsperaBreadcrumbs renders the breadcrumbs via a simple array
 *
 * @example
 * ```javascript
 * <AsperaBreadcrumbs items={this.breadcrumbs} />
 * ```
 */
export const AsperaBreadcrumbs = withRouter(class AsperaBreadcrumbs extends React.Component {
    constructor() {
        super(...arguments);
        this.handleFinalClick = (breadcrumb, _event) => {
            const { history } = this.props;
            if (typeof breadcrumb.onClick === 'function') {
                breadcrumb.onClick(breadcrumb);
            }
            if (typeof breadcrumb.route === 'string') {
                history.push(breadcrumb.route);
            }
            tracking.track('Navigate UI', { action: 'Clicked Breadcrumb Item', actionType: breadcrumb.name, successFlag: true });
        };
        this.handleClick = (breadcrumb, event) => {
            event.preventDefault();
            tracking.checkDirtyForms(() => this.handleFinalClick(breadcrumb, event));
        };
    }
    getBreadcrumbItem(breadcrumb, index, totalItems) {
        const { includesCurrentPage } = this.props;
        return (React.createElement(BreadcrumbItem, { href: breadcrumb.route || '#', key: index, "data-auto": `breadcrumb-item-${breadcrumb.route || 'no-route'}`, onClick: (event) => {
                this.handleClick(breadcrumb, event);
            }, isCurrentPage: includesCurrentPage && index === (totalItems - 1) }, breadcrumb.name));
    }
    getOverflowArea(start, end) {
        const { items } = this.props;
        if (!Array.isArray(items) || !(items === null || items === void 0 ? void 0 : items.length))
            return;
        return (React.createElement("span", { className: "cds--breadcrumb-item", key: "1" },
            React.createElement(OverflowMenu, { iconDescription: language.get('breadcrumbs.viewBreadcrumbs'), "aria-label": language.get('breadcrumbs.viewBreadcrumbs'), flipped: language.leftRightStyle, renderIcon: getIconComponent('OverflowMenuHorizontal'), "data-auto": "breadcrumb-overflow-menu" }, items.slice(start, end).map((breadcrumb, index) => {
                return React.createElement(OverflowMenuItem, { key: index, "data-auto": `breadcrumb-overflow-item-${breadcrumb.route}`, itemText: breadcrumb.name, onClick: (event) => {
                        this.handleClick(breadcrumb, event);
                    } });
            }))));
    }
    getBreadcrumbsChildren() {
        const { items } = this.props;
        if (!Array.isArray(items))
            return;
        if (items.length <= 3) {
            return items.map((breadcrumb, index) => {
                return this.getBreadcrumbItem(breadcrumb, index, items.length);
            });
        }
        else {
            const startPoint = items.length - 2;
            return [
                this.getBreadcrumbItem(items[0], 0, items.length),
                this.getOverflowArea(1, startPoint),
                ...(items.slice(startPoint).map((breadcrumb, index) => this.getBreadcrumbItem(breadcrumb, startPoint + index, items.length))),
            ];
        }
    }
    getBreadcrumbs() {
        const { items, includesCurrentPage } = this.props;
        if (Array.isArray(items)) {
            return (React.createElement(Breadcrumb, { className: "breadcrumbs", noTrailingSlash: includesCurrentPage }, this.getBreadcrumbsChildren()));
        }
        return '';
    }
    render() {
        const { className } = this.props;
        return (React.createElement("div", { className: `aspera-breadcrumbs ${className ? className : ''}` }, this.getBreadcrumbs()));
    }
});
